import { api, unwrap } from '@/core/http';

const lesson = (lesson_id: string) => ({ params: { path: { lesson_id } } });

export const learningApi = {
  audience: (lessonId: string) =>
    unwrap(api.GET('/v1/progress/lessons/{lesson_id}/audience', lesson(lessonId))),
  sessions: (q: { lessonId?: string; userId?: string }) =>
    unwrap(
      api.GET('/v1/progress/sessions', { params: { query: { lesson_id: q.lessonId, user_id: q.userId } } }),
    ),
  userReport: (userId: string) =>
    unwrap(api.GET('/v1/progress/users/{user_id}/report', { params: { path: { user_id: userId } } })),
};

export const insightsApi = {
  lesson: (lessonId: string, days: number) =>
    unwrap(
      api.GET('/v1/progress/lessons/{lesson_id}/insights', {
        params: { path: { lesson_id: lessonId }, query: { days } },
      }),
    ),
};
